import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";
import {
	Accordion,
	AccordionDetails,
	AccordionProps,
	AccordionSummary,
	AccordionSummaryProps,
	styled
} from "@mui/material";

// Styled Components for Modern UI
export const AGAccordion = styled((props: AccordionProps) => <Accordion disableGutters elevation={0} {...props} />)(
	({ theme }) => ({
		background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
		borderRadius: "12px",
		marginBottom: "8px",
		border: "1px solid rgba(0, 0, 0, 0.06)",
		transition: "all 0.3s ease",
		"&:hover": {
			transform: "translateY(-1px)"
		},
		"&::before": {
			display: "none"
		},
		"&.Mui-expanded": {
			margin: "8px 0"
		}
	})
);

export const AGAccordionSummary = styled((props: AccordionSummaryProps) => (
	<AccordionSummary expandIcon={<ArrowDropDownIcon />} {...props} />
))(({ theme }) => ({
	flexDirection: "row-reverse",
	padding: "16px 20px",
	borderRadius: "12px",
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1),
		alignItems: "center"
	},
	"& .MuiAccordionSummary-expandIconWrapper": {
		color: theme.palette.primary.main,
		transition: "transform 0.3s ease"
	},
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(180deg)"
	}
}));

export const AGAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
	padding: "20px",
	borderTop: "1px solid rgba(0, 0, 0, 0.08)",
	// background: "rgba(248, 249, 250, 0.5)",
	borderRadius: "0 0 12px 12px"
}));
